module.exports = __webpack_public_path__ + "static/project-main-workplace-one-a0b9a3ab755d10f11ea20c0fd804a976.jpg";